export class MediaUseReferenceModel {
    public mediaUseCode: string;
    public mediaUseName: string;
    public maximumSize: Number;
    public statusCode: string;
}